<script setup>
import ProductParagraph from 'vue-elements/product-info/ProductParagraph.vue';
import PricingTable from 'vue-elements/product-info/PricingTable.vue';
import PricingTableHeader from 'vue-elements/product-info/PricingTableHeader.vue';
import PricingTableRow from 'vue-elements/product-info/PricingTableRow.vue';
import Greenscore from '../product/Greenscore.vue';
import { computed } from 'vue';
import { iconsToSources } from '../../lib/product';

const props = defineProps({
    product: {
        type: Object,
        required: true,
    },
});

const electricitySources = computed(() => iconsToSources(props.product.electricity_source));

</script>



<template>
    <div class="product-details">
        <div class="package-discount">
            <product-paragraph>
                <template #heading>
                    Groenscore stroom
                </template>
                <template #value>
                    De groenscore van {{ product.provider_name }} is <Greenscore
                        :score="product.sustainability_score_total">
                    </Greenscore>

                    <br><br>

                    Deze groenscore is gebaseerd op een beoordeling op duurzaamheid door de Consumentenbond, Natuur &
                    Milieu
                    en Greenpeace.
                    Zij hebben {{ product.provider_name }} beoordeeld met een <strong>{{
                        product.sustainability_score_total
                        }}.</strong>

                    <br><br>

                    De groenscore wordt op de volgende manier bepaald:

                    <pricing-table class="details-rows">
                        <pricing-table-row>
                            <template #description>
                                <greenscore score="8.0" />
                            </template>
                            <template #value>
                                8 of hoger
                            </template>
                        </pricing-table-row>
                        <pricing-table-row>
                            <template #description>
                                <greenscore score="7.0" />
                            </template>
                            <template #value>
                                Tussen 6 en 8
                            </template>
                        </pricing-table-row>
                        <pricing-table-row>
                            <template #description>
                                <greenscore score="5.0" />

                            </template>
                            <template #value>
                                6 of lager
                            </template>
                        </pricing-table-row>
                    </pricing-table>
                </template>
            </product-paragraph>
            <product-paragraph v-if="product.electricity_green === 'compensated'">
                <template #heading>
                    Duurzaamheid van deze aanbieding
                </template>
                <template #value>
                    De elektriciteit van dit contract is duurzaam opgewekt in Europa. Dit is wel groene stroom,
                    maar wordt als minder duurzaam gezien dan groene stroom uit Nederland.
                </template>
            </product-paragraph>
            <product-paragraph v-if="product.electricity_green === 'nl'">
                <template #heading>
                    Duurzaamheid van deze aanbieding
                </template>
                <template #value>
                    De elektriciteit van dit contract is volledig duurzaam opgewekt in Nederland. Dit is de
                    meest duurzame stroom.
                </template>
            </product-paragraph>
            <product-paragraph v-if="product.electricity_green === 'gray'">
                <template #heading>
                    Duurzaamheid van deze aanbieding
                </template>
                <template #value>
                    De elektriciteit van dit contract bestaat uit grijze stroom. Dit is de minst duurzame vorm
                    van stroom.
                </template>
            </product-paragraph>
        </div>
        <pricing-table class="details-rows">
            <pricing-table-header>
                <strong>Hier komt je stroom vandaan:</strong>
            </pricing-table-header>

            <pricing-table-row v-for="electricitySource in electricitySources" :key="electricitySource.label">
                <template #description>
                    {{ electricitySource.label }}
                </template>
                <template #value>
                    {{ electricitySource.percentage }}%
                </template>
            </pricing-table-row>
        </pricing-table>
    </div>
</template>